<div mat-dialog-title>
  <h2>Pipe content from:</h2>
</div>
<mat-dialog-content>
  <div class="editor-question-form__input">
    <span class="fs__md fw__500">Question</span>
    <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
      <input
        #input
        matInput
        [matAutocomplete]="auto"
        type="text"
        placeholder="Select a previous question"
        aria-label="Select a previous question"
        (input)="filter()"
        (focus)="filter()"
      />
      <mat-autocomplete
        requireSelection
        #auto="matAutocomplete"
        class="eiq-no-wrap-option"
        [classList]="'eiq-no-wrap-option'"
        (optionSelected)="onQuestionSelected($event)"
      >
        @if (activeQuestionId | inBlock; as onBlock) {
          <mat-option [value]="loopOptionValue">Loop Block - Current loop value</mat-option>
        }

        @for (prevQuestion of filteredQuestions; track prevQuestion.id) {
          <mat-option [value]="prevQuestion.code">{{ prevQuestion.code }} - {{ prevQuestion.title | toPlainText }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  @if (selectedQuestion) {
    @if (selectedQuestion.cards?.length > 0) {
      <div class="editor-question-form__input">
        <span class="fs__md fw__500">Card</span>
        <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-select [(ngModel)]="cardSelected" [ngModelOptions]="{ standalone: true }" aria-label="Pick case">
            @for (card of selectedQuestion.cards; track card.id) {
              <mat-option [value]="card.id">{{ card.text | toPlainText }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    @if (this.selectedQuestion.type === questionType.RankSort) {
      <div class="editor-question-form__input">
        <span class="fs__md fw__500">Rank</span>
        <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-select [(ngModel)]="rankSelected" [ngModelOptions]="{ standalone: true }" aria-label="Pick rank">
            @if (selectedQuestion.ranks && selectedQuestion.ranks.length > 0) {
              @for (rank of selectedQuestion.ranks; track rank.id) {
                <mat-option [value]="rank.id">{{ rank.text | toPlainText }}</mat-option>
              }
            } @else {
              @for (position of [].constructor(selectedQuestion.ratingScale); track position; let index = $index) {
                <mat-option [value]="'rank_'+(+index+1)">Rank position {{ index + 1 }}</mat-option>
              }
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    @if (this.selectedQuestion.type === questionType.Ranking) {
      <div class="editor-question-form__input">
        <span class="fs__md fw__500">Rank</span>
        <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-select [(ngModel)]="rankSelected" [ngModelOptions]="{ standalone: true }" aria-label="Pick rank">
            @for (option of selectedQuestion.options; track option; let index = $index) {
              <mat-option [value]="option.id">Rank position {{ index + 1 }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <div class="editor-question-form__input">
      <span class="label">Case</span>
      <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
        <mat-select [(ngModel)]="formatSelected" [ngModelOptions]="{ standalone: true }" aria-label="Pick case">
          @for (format of pipeFormatOptions; track format.value) {
            <mat-option [value]="format.value">{{ format.text }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="onClose()">Cancel</button>
  <button mat-flat-button [color]="'primary'" (click)="onComplete()">Apply</button>
</mat-dialog-actions>
